import type { CustomerBalanceTransaction } from '@src/types';
import { createContext, useContext } from 'react';
import type { Observable } from 'rxjs';

export const BalanceTransactionsContext = createContext<{
  transactionsByIdObs: Observable<Map<string, CustomerBalanceTransaction>>;
  transactionsListObs: Observable<CustomerBalanceTransaction[]>;
  sessionTransactionsObs: Observable<CustomerBalanceTransaction>;
}>(null!);

export function useBalanceTransactionsContext() {
  const context = useContext(BalanceTransactionsContext);
  if (!context) {
    throw new Error('useBalanceTransactionsContext must be used within a BalanceTransactionsContext');
  }
  return context;
}
